/**
 * @desc 生成box单号
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inMaster.createBoxNo.Params, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/createBoxNo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
